import clsx from "clsx";
import { useTranslation } from "react-i18next";

type PillProps = {
  text: string | React.ReactNode;
  className?: string;
};

export const PromoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 20 20"
    >
      <rect
        width="20"
        height="20"
        fill="url(#paint0_linear_40004612_25779)"
        rx="10"
      ></rect>
      <path
        fill="#FEFEFE"
        d="M5.175 8.308q0 1.074.211 1.6.213.527.694.527.965 0 .965-2.127T6.08 6.182q-.481 0-.694.526-.21.526-.211 1.6m3.287-.014q0 1.657-.606 2.494-.6.83-1.776.829-1.11 0-1.724-.858-.606-.865-.606-2.465Q3.75 5 6.08 5q1.147 0 1.761.858.621.85.621 2.436m3.667 4.224q0 1.074.212 1.607.22.534.701.534.957 0 .957-2.141 0-2.112-.957-2.112-.482 0-.7.519-.213.519-.213 1.593m3.288 0q0 1.658-.607 2.486-.606.83-1.768.83-1.11 0-1.724-.851-.613-.858-.613-2.465 0-3.294 2.337-3.294 1.125 0 1.746.85.63.85.629 2.444m-2.17-7.367L7.322 15.69H5.905L11.83 5.151z"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_40004612_25779"
          x1="6.25"
          x2="17.083"
          y1="12.083"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#34C759"></stop>
          <stop offset="1" stopColor="#0FF"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
};

const Pill = ({ text, className }: PillProps) => {
  return (
    <div
      className={clsx(
        "h-[26px] py-[2px] px-[10px] max-w-fit bg-cerulean-blue-100 rounded-full text-center text-noble-blue-500 font-semibold",
        className
      )}
      style={{ fontSize: "12px", lineHeight: "22px" }}
    >
      {text}
    </div>
  );
};

export const PromoPill = () => {
  const { t } = useTranslation("common");

  return (
    <Pill
      text={
        <div className="flex items-center gap-x-1">
          <PromoIcon />
          {t("promoAvailable")}
        </div>
      }
      className="!bg-[#EAFFEF] !text-[#34C759]"
    />
  );
};
